var youbora = require('youboralib')
var manifest = require('../../manifest.json')

var GenericAdsAdapter = youbora.Adapter.extend({
  getVersion: function () {
    return manifest.version + '-radiantmp-ads'
  },

  getDuration: function () {
    return this.player.getAdDuration() / 1000
  },

  getResource: function () {
    return this.player.getAdMediaUrl()
  },

  getPlayhead: function () {
    return this.player.getAdCurrentTime() / 1000
  },

  getTitle: function () {
    return this.player.getAdTitle()
  },

  getPosition: function () {
    var playhead = this.plugin.getAdapter().getPlayhead()
    var duration = this.plugin.getAdapter().getDuration()
    if (playhead < 0.1) {
      return 'pre'
    }
    if (playhead === duration && duration !== 0) {
      return 'post'
    }
    return 'mid'
  },

  /** Register listeners to this.player. */
  registerListeners: function () {

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false)

    // References
    this.references = []
    this.references['adtagstartloading'] = this.playListener.bind(this)
    this.references['adstarted'] = this.joinListener.bind(this)
    this.references['adpaused'] = this.pauseListener.bind(this)
    this.references['adresumed'] = this.resumeListener.bind(this)
    this.references['aderror'] = this.errorListener.bind(this)
    this.references['adclosed'] = this.endedListener.bind(this)
    this.references['adcomplete'] = this.endedListener.bind(this)
    this.references['adskipped'] = this.skippedListener.bind(this)
    this.references['adclick'] = this.onClickListener.bind(this)
    this.references['adloadererror'] = this.notServedListener.bind(this)
    this.references['adblockerdetected'] = this.blockedListener.bind(this)
    this.references['adalladscompleted'] = this.endedAdsListener.bind(this)
    // Register listeners
    for (var key in this.references) {
      this.player.dom.container.addEventListener(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.dom.container.removeEventListener(key, this.references[key])
      }
      this.references = []
    }
  },

  /** Listener for 'adtagstartloading' event. */
  playListener: function (e) {
    if (this.player.adParser !== "rmp-vast") this.plugin.getAdapter().blockedStop = true
    this.fireStart()
  },

  /** Listener for 'adstarted' event. */
  joinListener: function (e) {
    if (this.player.adParser !== "rmp-vast") this.plugin.getAdapter().blockedStop = true
    this.fireStart()
    this.fireJoin()
    this.duration = this.getDuration()
  },

  /** Listener for 'adpaused' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'adresumed' event. */
  resumeListener: function (e) {
    this.fireResume()
    this.fireJoin()
  },

  /** Listener for 'aderror' event. */
  errorListener: function (e) {
    this.fireError()
  },

  /** Listener for 'adclosed' and 'adcomplete' events. */
  endedListener: function (e) {
    this.fireStop({ 'adPlayhead': this.duration })
  },

  /** Listener for 'adskipped' event. */
  skippedListener: function (e) {
    this.fireStop({ 'skipped': true })
  },

  /** Listener for 'adclick' event. */
  onClickListener: function (e) {
    this.fireClick()
  },

  /** Listener for 'adloadererror' event. */
  notServedListener: function (e) {
    this.fireError('Ad not served')
    this.fireStop()
  },

  /** Listener for 'adblockerdetected' event. */
  blockedListener: function (e) {
    this.fireError('Ad blocked')
    this.fireStop()
  },

  /** Listener for 'adalladscompleted' event. */
  endedAdsListener: function (e) {
    this.plugin.getAdapter().blockedStop = false
    this.fireStop()
    if (this.getPosition() === 'post') {
      this.plugin.getAdapter().fireStop()
    }
  }
})

module.exports = GenericAdsAdapter
